'use strict';

import React, { Component } from 'react'

import { capitalize } from '@root/utility'

import Layout   from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import TutorialIcon from '@/Icons/Tutorial'

import Image  from '@Pure/Image'
import Link   from '@Pure/Link'
import Loader from '@Pure/Loader'

import bemit from '@function/bemit'

const moment = window.moment;

const { app, qwest } = window;

export default class TutorialsPage extends Component
{
	state =
	{
		data: [],

		references: [],

		role: app.state.session.permissions?.title,

		pagination:
		{
			max_items: 30,
			limit: 30,
			skip: 0
		},

		searched:
		{
			value: ''
		}
	};

	fetched = false;

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, config = this.props.config;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange();
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session?.id) return;

		component.setState(
		{
			role: app.state.session.permissions?.title
		});

		if (component.fetched === true) return;

		component.fetchData({ role: app.state.session.permissions?.title });
	}

	fetchData = ({ role }) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ loading: true });

		let filter_query =
		{
			sort: 'date DESC',

			type: (role || state.role) === 'EC'
			? 'EC'
			: 'classic'
		};

		qwest.post('/CMS/getAll',
		{
			model: 'Tutorial'.toLowerCase(),
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,

				data: response.data || []
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			component.setState({ loading: false });

			app.ajaxRedirectLogin(response);
		});
	}

	getPagination = () =>
	{
		const component = this, props = this.props, config = this.props.config;

		let limit     = this.state.pagination.limit, skip = this.state.pagination.skip;
		let max_items = this.state.pagination.max_items;

		let total_items = component.state.data.length;

		let pagination = [];

		for (let i = 0; i < total_items; i += max_items)
		{
			let data =
			{
				items_count: (i + max_items > total_items) ? (total_items - i) : (max_items),
				skip: i
			};

			data.limit = i + data.items_count;

			pagination.push(data);
		}

		pagination = pagination.map(function (data, index)
		{
			let is_active = component.state.pagination.limit === data.limit;

			let output =
			(
				<div key={ index } className={ 'c-pagination-item' +
					(is_active ? ' c-pagination-item--active' : '') }
					onClick={ function () { setPagination(data); } }>
					{ index + 1 }
				</div>
			);

			return output;
		});

		return pagination;

		function setPagination (data)
		{
			let pagination = Object.assign({ }, component.state.pagination);

			pagination.limit = data.limit;
			pagination.skip  = data.skip;

			component.setState({ pagination: pagination });
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader"
				bemit={ ['primary', 'bg-light', 'medium', 'Tutorials'] }
			/>
		)
		: undefined;

		let tutorials = state.data.filter(function (element, index)
		{
			if (props.pagination === false)
			{
				return true;
			}

			return index < state.pagination.limit && index >= state.pagination.skip;
		})
		.map(function (tutorial, key)
		{
			const img_or_icon = (tutorial.thumbnail || [])[0]?.url ?
			(
				<Image className="c-model-preview__tuto-thumbnail"
					src={ tutorial.thumbnail[0].url }
				/>
			)
			:
			(
				<TutorialIcon className={ bemit('o-inline-icon',
					['tutorial']) + ' c-model-preview__tuto-icon' }
				/>
			);

			const output =
			(
				<div className="c-model-preview-item tutorial o-grid__item u-flex"
					key={ tutorial.id + key }>

					<div className="c-model-preview c-model-preview--tutorial">

						<div className="c-model-preview__thumb">
							<Link className="c-model-preview__thumb-link"
								href={ '/accueil/mon-espace/tutoriels/' +
									tutorial.id }>
								{ img_or_icon }
							</Link>
						</div>

						<h2 className="c-model-preview__title">
							<Link href={ '/accueil/mon-espace/tutoriels/' +
								tutorial.id } className="c-model-preview__title-link">
								{ tutorial.title }
							</Link>
						</h2>

						<p className="c-model-preview__subtitle">
							{ capitalize(moment(tutorial.date).format('dddd')) }
							{ moment(tutorial.date).format(' DD MMMM YYYY') }
						</p>

						<div className="c-model-preview__infos">

							<div className="c-model-preview__buttons">
								<Link href={ '/accueil/mon-espace/tutoriels/' +
									tutorial.id } className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Voir le tutoriel
								</Link>
							</div>

						</div>

					</div>

				</div>
			);

			return output;
		});

		let pagination = component.getPagination();

		if (!pagination || pagination.length <= 1)
		{
			pagination = undefined;
		}

		var output =
		(
			<Layout history={ props.history } page_title="Tutoriels vidéo">

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<div className="c-pagination u-margin-bottom-15">
							{ pagination }
						</div>

						<div className="u-negative-margin">

							<div className="o-grid-6 u-flex">
								{ loader || tutorials }
							</div>

						</div>

						<div className="c-pagination u-margin-top-15">
							{ pagination }
						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}